import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import fb from "@bd-core/firebase";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import {
    getAttributes,
    setIsSendingPostCard,
    setPostCardSent,
} from "@bd-core/firebase-actions";
import { numberPicker } from "../static/numberpicker";

export const outroPage = async () => {
    const isLoginPage = $("#page-outro").length > 0;
    if (!isLoginPage) return false;

    bdjs.hideLoading();

    let isMeCurrentLeader = false;
    const elms = {
        outro: ".js-outro",
        selectEvent: ".js-select-event",
        eventValue: "#eventpicker",
        eventLabel: ".js-picker-label",
        datePicker: ".js-date-picker",
        submitDateButton: ".js-submit-date",
        togglePreviewBtn: ".js-toggle-outro",
        sendEmail: ".js-send-email",
        emailList: ".js-email-list",
        emailMember: ".js-email-member",
        addEmailBtn: ".js-add-email",
        emailInput: ".js-post-card-email",
        deleteEmail: "js-remove-email",
        closeBriefingBtn: ".js-info-button",
    };

    const init = async () => {
        const snapshot = await fb.get(`${fb.teamAttributesPath}/leader`);
        if (snapshot.val() === CONFIG.user.id) {
            isMeCurrentLeader = true;
        }

        registerEvents();
        setPageText();
        setupSlider();
        setTimeout(function () {
            toggleBriefingPopup();
            $("#page-outro").addClass("is-active");
            toggleSendButton();
        }, 100);

        $(".js-leaderboard-slide").slick();

        /** Events */
        fb.onValue(`${fb.teamAttributesPath}`, onLeaderSendingEmail.bind(this));

        fb.onValue(
            `${fb.teamAttributesPath}/postcard`,
            maybeUpdatePostcardValue.bind(this),
        );

        numberPicker();
    };

    const registerEvents = () => {
        $(document).on("click", elms.selectEvent, onSelectEvent);
        $(document).on("click", elms.submitDateButton, onSubmitDate);
        $(elms.togglePreviewBtn).on("click", onTogglePreview);
        $(elms.sendEmail).on("click", sendEmail);
        $(elms.addEmailBtn).on("click", addEmail);
        $(elms.closeBriefingBtn).on("click", toggleBriefingPopup);
        $(document).on("click", ".snackbar__close", closeSnackBar);

        $(document).on("click", function (e) {
            var container = $(".postCard__appointment");
            const $this = $(e.target);

            if (
                // @ts-ignore
                !container.is($this) &&
                // @ts-ignore
                container.has($this).length === 0
            ) {
                $(".postCard__picker").removeClass("is-active");
            }
        });

        $(document).on("click", ".js-remove-email", function () {
            if (!isMeCurrentLeader) {
                return;
            }
            $(this).parent().remove();
        });

        $(document).on("click", ".js-picker", function () {
            if (!isMeCurrentLeader) {
                return;
            }

            $(this).next().addClass("is-active");
        });

        if (!isMeCurrentLeader) {
            $(elms.addEmailBtn).addClass("disabled");
            $(elms.emailInput).attr("disabled", "disabled");
        }
    };

    const toggleBriefingPopup = () => {
        const $briefingPopup = $(".js-info-popup");
        const isOpened = $briefingPopup.hasClass("active");

        $briefingPopup.toggleClass("active", !isOpened);
    };

    const setPageText = () => {
        // @ts-ignore
        const pageData = CONFIG.game.setup;
        const { page_title, postcard_text } = pageData;
        const { description } = postcard_text;
        const date_picker_html = `
        <span class="postCard__appointment">
            <a class="postCard__appointment-label js-picker" title="Pick a date" id="datePicker">                                                    
                <span class="default">Pick a date</span>
                <span class="filler"></span>
                <input type="hidden" id="finalDate" value=""/>
            </a>
            <span class="postCard__picker is-reversed-disabled">
                <span class="postCard__picker-inner js-date-picker-inner">
                </span>
            </span>
        </span>`;

        const $datePicker = `
        <div class="datePicker js-date-picker">
            <div class="datePicker__row">
                <label class="datePicker__label">
                    <span>Insert date</span>
                    <span class="placeholder">
                        <button id="dateField" class="placeholder-num numberPicker js-numberpicker" data-np-min="1" data-np-max="31" title="Date" data-picker="date">
                            <span class="numberPicker__label js-numberpicker-label">--</span>
                            <span class="numberPicker__float">
                            </span>
                            <input type="hidden" id="dateVal" value="" class="js-picker-field"/>
                        </button>
                        <button id="monthField" class="placeholder-num numberPicker js-numberpicker" data-np-min="1" data-np-max="12" title="Month" data-picker="month">
                            <span class="numberPicker__label js-numberpicker-label">--</span>
                            <span class="numberPicker__float">
                            </span>
                            <input type="hidden" id="monthVal" value="" class="js-picker-field"/>
                        </button>
                        <button id="yearField" class="placeholder-num numberPicker js-numberpicker" data-np-min="2024" data-np-max="2030" title="Year" data-picker="year">
                            <span class="numberPicker__label js-numberpicker-label">----</span>
                            <span class="numberPicker__float">
                            </span>
                            <input type="hidden" id="yearVal" value="" class="js-picker-field"/>
                        </button>
                    </span>
                </label>
                <label class="datePicker__label">
                    <span>Insert time</span>
                    <span class="placeholder">
                        <button id="hourField" class="placeholder-num numberPicker js-numberpicker" data-np-min="0" data-np-max="23" title="Hour" data-picker="hour">
                            <span class="numberPicker__label js-numberpicker-label">--</span>
                            <span class="numberPicker__float">
                            </span>
                            <input type="hidden" id="hourVal" value="" class="js-picker-field"/>
                        </button>
                        <button id="minuteField" class="placeholder-num numberPicker js-numberpicker" data-np-min="0" data-np-max="59" title="Minute" data-picker="minute">
                            <span class="numberPicker__label js-numberpicker-label">--</span>
                            <span class="numberPicker__float">
                            </span>
                            <input type="hidden" id="minuteVal" value="" class="js-picker-field"/>
                        </button>
                    </span>
                </label>
            </div>
            <div class="datePicker__action">
                <button class="js-submit-date btn btn-primary" title="Submit" disabled>
                    <span>Submit</span>
                </button>
            </div>
        </div>`;

        const newDescription = description.replaceAll(
            "{select_date}",
            date_picker_html,
        );
        const $postcardText = $(".js-postcard-text");
        $postcardText.html(newDescription);
        $(".js-date-picker-inner").append($datePicker);
        $(".js-challenge-title").html(page_title);

        const postCardPickerDate = $(".js-date-picker-inner").parent();
        const offset = $(".postCard__picker").offset();
        const elementHeight = $(".js-date-picker-inner").height();
        const pageHeight = $(window).height();
        const isOffScreenOver = pageHeight - offset.top < elementHeight;

        if (isOffScreenOver) {
            postCardPickerDate.removeClass("is-reversed");
        }
    };

    const setupSlider = () => {
        const sliderInfoPopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item.nav-pagination"),
            prevArrow: $(".msn-popup__nav-item.nav-left"),
            nextArrow: $(".msn-popup__nav-item.nav-right"),
        };

        $(".js-info-slider-wrapper").slick(sliderInfoPopup);
        $(".js-info-slider-wrapper").slick("refresh");
    };

    const addEmail = function () {
        if (!isMeCurrentLeader) {
            return;
        }

        const emailAddress = String($(elms.emailInput).val()).trim();
        const testString = /<\/?[a-z][\s\S]*>/i.test(emailAddress); // check if the string contain html tag
        if (emailAddress === "" || testString) return;

        const addedEmail =
            '<div class="addEmail__account js-email-member"><span class="js-email-name">' +
            emailAddress +
            '</span><button class="js-remove-email" title="delete"><span>Delete</span></button></div>';

        $(elms.emailList).append(addedEmail);
        $(elms.emailInput).val("");
        toggleSendButton();
    };

    const onSelectEvent = function (v) {
        v.preventDefault();
        v.stopPropagation();
        const $this = $(this);
        const eventName = $this.data("event");
        const dataField = $this.data("picker");
        const $field = $("#" + dataField);
        const $siblings = $this.siblings();
        const $labelHolder = $(elms.eventLabel);
        const $labelFiller = $labelHolder.find(".filler");
        const isLeader = isMeCurrentLeader;

        if (!isLeader) return;

        $siblings.removeClass("is-selected");
        $this.addClass("is-selected");
        $labelHolder.addClass("is-filled");
        $labelFiller.text(eventName);
        $field.val(eventName);

        fb.update(`${fb.teamAttributesPath}/postcard`, {
            event: eventName,
        });

        $this.parents(".postCard__picker").removeClass("is-active");
        toggleSendButton();
    };

    const onSubmitDate = function () {
        const date = $("#dateVal").val();
        const month = $("#monthVal").val();
        const year = $("#yearVal").val();
        const hour = $("#hourVal").val();
        const minute = $("#minuteVal").val();
        const dateString = date + "/" + month + "/" + year;
        const timeString = hour + ":" + minute;
        const finalSet = dateString + " at " + timeString;
        const isLeader = isMeCurrentLeader;

        if (!isLeader) return;

        $("#datePicker").addClass("is-filled");
        $("#datePicker").find(".filler").html(finalSet);
        $("#finalDate").val(finalSet);

        fb.update(`${fb.teamAttributesPath}/postcard`, {
            date: dateString,
            time: timeString,
        });

        $(this).parents(".postCard__picker").removeClass("is-active");
        toggleSendButton();
    };

    const onTogglePreview = function () {
        const $outro = $(elms.outro);

        if ($(this).hasClass("cardToggle")) {
            $outro
                .removeClass("is-preview-result")
                .addClass("is-writing-email");
        } else {
            $outro
                .removeClass("is-writing-email")
                .addClass("is-preview-result");
        }
    };

    const toggleSendButton = () => {
        const $sendBtn = $(elms.sendEmail);
        const $emailMember = $(elms.emailMember);
        const $eventPicker = $(elms.eventLabel);
        const selectedEvent = $(elms.eventValue).val();
        const $datePicker = $(elms.datePicker);
        const finalDate = $("#finalDate").val();

        // check if selected event empty
        if ($eventPicker.length != 0 && selectedEvent === "") return;

        // check if date picker not completely filled
        if ($datePicker.length != 0 && finalDate === "") return;

        // check if no email member list
        if ($emailMember.length == 0) return;

        getAttributes()
            .then((data) => {
                const attributesData = data.val() || {};
                const currentPlayerId = CONFIG.user.id;
                const leaderId = attributesData?.leader || 0;
                const isCurrentLeader = currentPlayerId === leaderId;
                const isPostcardSend = attributesData?.isPostcardSent || false;

                if (isCurrentLeader && !isPostcardSend) {
                    $sendBtn.removeClass("hidden");
                }
            })
            .catch();
    };

    const goToLeaderBoardPage = async () => {
        const url = window.location.href;
        const newUrl = url.replace("result", "leaderboard");

        fb.update(`${fb.teamAttributesPath}`, {
            isSendingPostcard: false,
        }).then(() => (window.location.href = newUrl));
    };

    const sendEmail = async function () {
        const $sendBtn = $(elms.sendEmail);
        if ($sendBtn.hasClass("is-loading")) {
            return;
        }

        $sendBtn.addClass("is-loading");

        const $emailMember = $(elms.emailMember);
        const selectedEvent = $(elms.eventValue).val();
        const $selectedDate = $(elms.datePicker).find(".js-picker-field");
        // check if selected event empty
        if (selectedEvent === "") return;

        let isFieldFilled = true;
        let finalDate = [];
        $.each($selectedDate, function (index, item) {
            const $this = $(item);
            const answer = $this.val();

            if (answer === "") {
                return (isFieldFilled = false);
            } else {
                const pickerType = $this.parent().attr("data-picker");
                finalDate[pickerType] = answer;
            }
        });

        // check if date picker not completely filled
        if (!isFieldFilled) return;

        // check if no email member list
        if ($emailMember.length == 0) return;

        let membersEmail = [];
        $.each($emailMember, function (index, item) {
            const theEMail = $(item).find(".js-email-name").text();
            if (theEMail !== "") membersEmail.push(theEMail);
        });

        // @ts-ignore
        const date = `${finalDate.month}/${finalDate.date}/${finalDate.year}`;
        // @ts-ignore
        const time = `${finalDate.hour}:${finalDate.minute}`;

        const [res] = await bdjs.goAsync(
            bdapi.post("game/send-postcard", {
                event: selectedEvent,
                date: date,
                time: time,
                membersEmail: membersEmail,
            }),
        );

        const resData = res?.data || {};
        // console.log(resData)

        if (resData?.success) {
            setIsSendingPostCard();
            setPostCardSent();
            // $(elms.outro).addClass("is-sending-mail");

            // setTimeout(function () {
            // goToLeaderBoardPage();
            // }, 4000);
        } else {
            const $snackBar = $(".snackbar");
            const msg =
                resData?.data?.message ||
                "Something went wrong. Please try again!";

            $snackBar.addClass("is-active").find(".snackbar__body").html(msg);
        }

        $sendBtn.removeClass("is-loading");
    };

    let localIsSending = false;
    const onLeaderSendingEmail = (snapshot) => {
        const attributeData = snapshot.val();
        const is_sending = attributeData?.isSendingPostcard || false;

        if (is_sending && !localIsSending) {
            localIsSending = true;
            $(elms.outro).addClass("is-sending-mail");

            setTimeout(function () {
                goToLeaderBoardPage();
            }, 4000);
        }
    };

    const closeSnackBar = () => {
        const $snackBar = $(".snackbar");
        $snackBar.removeClass("is-active");
    };

    const maybeUpdatePostcardValue = (snapshot) => {
        const postcardData = snapshot.val();

        if (!postcardData) return;

        if (postcardData.event) {
            const theEvent = postcardData.event;
            const $selectedEvent = $(
                `${elms.selectEvent}[data-event="${theEvent}"]`,
            );
            const dataField = $selectedEvent.attr("data-picker");
            const $field = $("#" + dataField);
            const $labelHolder = $(elms.eventLabel);
            const $labelFiller = $labelHolder.find(".filler");

            $(elms.selectEvent).removeClass("is-selected");
            $selectedEvent.addClass("is-selected");
            $labelHolder.addClass("is-filled");
            $labelFiller.text(theEvent);
            $field.val(theEvent);
        }

        if (postcardData.date && postcardData.time) {
            const finalDate = `${postcardData.date} at ${postcardData.time}`;
            const dateArr = postcardData.date.split("/");
            const timeArr = postcardData.time.split(":");

            $("#dateVal").val(dateArr[0]);
            $("#monthVal").val(dateArr[1]);
            $("#yearVal").val(dateArr[2]);
            $("#hourVal").val(timeArr[0]);
            $("#minuteVal").val(timeArr[1]);
            $("#datePicker").addClass("is-filled");
            $("#datePicker").find(".filler").html(finalDate);
            $("#finalDate").val(finalDate);
        }

        toggleSendButton();
    };

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        await fb.initializeGame().then();
    } catch (e) {
        console.error(e);
    }
    //----------------------------------------------------------------------- End Initialize Firebase

    init();
};
